import React from 'react';
import { Box, Button, Stack, SvgIcon, Typography } from '@mui/material';
import getMuiIcon from '../../../utils/getMuiIcon';
import { useTranslation } from 'react-i18next';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import useScreenSize from '../../../utils/useScreenSize';
import { generateCertificatePDF } from '../utils';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../reducers/user.selectors';
import { CourseRegistration } from '@kimuno/api-sdk/lib/types/responses/CourseRegistration';

const CourseFinishPageSuccess: React.FC<{
  courseRegistration: CourseRegistration;
}> = ({ courseRegistration }) => {
  const { t } = useTranslation();
  const { isXsScreen } = useScreenSize();
  const user = useSelector(selectUser);

  const redirectToCertificatePage = async () => {
    const certificateUrl = await generateCertificatePDF(user, courseRegistration.mindItemId);
    window.open(certificateUrl, '_blank');
  };

  return (
    <Stack data-testid='course-finish-page-success' alignItems='center' gap={spaces.xl} paddingY={spaces.xxl}>
      <Box
        component={getMuiIcon('courseSuccess')}
        sx={{
          width: isXsScreen ? '343px' : '400px',
          height: isXsScreen ? '258px' : '300px',
        }}
      />
      <Typography
        color={palette.text.primary}
        variant='h6'
        maxWidth={448}
        textAlign='center'
      >
        {t(
          'You have successfully completed the course {{courseName}} and received a certificate.',
          { courseName: `"${courseRegistration.mindItem?.title}"` || '' }
        )}
      </Typography>
      <Button
        variant='contained'
        size='large'
        color='primary'
        startIcon={
          <SvgIcon component={getMuiIcon('importIcon')} viewBox='0 0 20 20' />
        }
        onClick={redirectToCertificatePage}
      >
        {t('Download certificate')}
      </Button>
    </Stack>
  );
};

export default CourseFinishPageSuccess;
